<template>
  <div>
    <v-tabs v-model="activeTab" center-active small>
      <v-tab v-for="(tab, index) in tabs" :key="index" :href="'#' + tab.id">
        <v-icon small class="px-2">{{ tab.icon }}</v-icon>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item value="reliability">
        <reliability :exam-statistics-data="ExamStatisticsData.reliability" :questions="Questions"></reliability>
      </v-tab-item>
      <v-tab-item value="validity">
        <internalValidity
          :exam-statistics-data="ExamStatisticsData.internalValidity" :questions="Questions"
        ></internalValidity>
      </v-tab-item>
      <v-tab-item value="discrimination">
        <discrimination :exam-statistics-data="ExamStatisticsData.discrimination" :questions="Questions"></discrimination>
      </v-tab-item>
      <v-tab-item value="difficulty">
        <difficulty :exam-statistics-data="ExamStatisticsData.difficulty" :questions="Questions"></difficulty>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reliability from "./reliability.vue";
import internalValidity from "./internalValidity.vue";
import discrimination from "./discrimination.vue";
import difficulty from "./difficulty.vue";

export default {
  name: "ExamAnalytics",
  props: {
    ExamStatisticsData: {
      type: Object,
      required: true
    },
    Questions: {
      type: Array,
      required: true
    }
  },
  components: {
    reliability,
    internalValidity,
    discrimination,
    difficulty
  },
  data() {
    return {
      activeTab: "reliability",
      tabs: [
        { id: "reliability", name: this.$t('examAnalytics.reliability'), icon: "mdi-chart-line" },
        { id: "validity", name: this.$t('examAnalytics.validity'), icon: "mdi-check-circle" },
        { id: "discrimination", name: this.$t('examAnalytics.discrimination'), icon: "mdi-scale-balance" },
        { id: "difficulty", name: this.$t('examAnalytics.difficulty'), icon: "mdi-gauge" }
      ]
    };
  },

  mounted() {
    this.$nextTick(() => {
      //this.computeReliabilityChart();
      // this.computeValidityChart();
      //this.computeDiscriminationChart();
      //this.computeDifficultyChart();
    });
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        if (this.activeTab === "reliability") {
          //this.computeReliabilityChart();
        } else if (this.activeTab === "validity") {
          //this.computeValidityChart();
        } else if (this.activeTab === "discrimination") {
          // this.computeDiscriminationChart();
        } else if (this.activeTab === "difficulty") {
          //this.computeDifficultyChart();
        }
      });
    }
  }
};
</script>

<style scoped>
.rounded-button {
  border-radius: 0.375rem;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
